import { getApiUrl, type MarketResponseDto } from "Infrastructure/Api/Api";
import { useMarketListQuery } from "Market/Api/Query/useMarketListQuery";
import { MarketPaths } from "Market/Routes/Routing";
import { Scrollbar } from "Shared/Components/Scroll/Scrollbar";
import {
	LinearProgress,
	List,
	ListItemButton,
	ListItemText,
	Stack,
} from "@mui/material";
import { useNavigate, useParams } from "react-router";

export const MarketsList = () => {
	const navigate = useNavigate();
	const { urlPath: marketUrlPath } = useParams();

	const { data: markets, isLoading } = useMarketListQuery();

	const handleNavigateMarketEdit = (marketUrlPath: string) => {
		navigate(MarketPaths.EditGeneral.path(marketUrlPath));
	};

	return (
		<Stack>
			<List sx={{ overflow: "hidden" }}>
				<Scrollbar sx={{ maxHeight: { xs: 200, md: 350 } }}>
					{isLoading && (
						<LinearProgress
							sx={{
								height: "1px",
							}}
						/>
					)}
					{markets?.map((market: MarketResponseDto) => (
						<ListItemButton
							selected={marketUrlPath === market.urlPath}
							key={market.id}
							onClick={() => handleNavigateMarketEdit(market.urlPath)}
							sx={{ gap: 1 }}
						>
							<img
								src={`${getApiUrl()}${market.iconPath}`}
								alt="market flag"
								style={{
									width: "20px",
								}}
							/>
							<ListItemText>{market.name}</ListItemText>
						</ListItemButton>
					))}
				</Scrollbar>
			</List>
		</Stack>
	);
};
